import { type Context, createContext, useContext } from 'react';

type IsDisabledContextType = boolean;

export const IsDisabledContext: Context<boolean> = createContext<IsDisabledContextType>(false);

export const useIsDisabledContext = (): boolean =>
	useContext<IsDisabledContextType>(IsDisabledContext);
